
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/services/feature-engineering",
      function () {
        return require("private-next-pages/services/feature-engineering.tsx");
      }
    ]);
  